import React, { useEffect, useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import "./style.css";

const ControlledTabs = (props) => {
  const [key, setKey] = useState(
    props.options.length > 0
      ? props.options[0].title.toLowerCase()
      : props.activeTab
  );

  useEffect(() => {
    if (props.activeTab) {
      setKey(props.activeTab);
    }
  }, []);

  return (
    <>
      <Tabs
        id="controlled-tab-example"
        activeKey={key}
        onSelect={(k) => {
          setKey(undefined);
          setKey(k);
        }}
        className={`tab gap-3 flex-nowrap ${props.className}`}
        style={props.styles}
      >
        {props.options.map((item, i) => {
          return (
            <Tab key={i} eventKey={item.title.toLowerCase()} title={item.title}>
              {item.data}
            </Tab>
          );
        })}
      </Tabs>
    </>
  );
};

export default ControlledTabs;
